import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-unused-vars */
var MASK_TYPES = {
  DATE: 'ds-mask-date',
  DATE_DEPRECATED: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  DATE_TIME: 'ds-mask-date-time',
  DATE_TIME_DEPRECATED: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/],
  DICTIONARY: function DICTIONARY(props) {
    return _objectSpread({
      type: 'ds-mask-dictionary'
    }, props);
  },
  PHONE: 'ds-mask-phone',
  PHONE_INTENATIONAL: 'ds-mask-phone-international',
  SSN: 'ds-mask-ssn',
  US_ZIP_CODE: 'ds-mask-us-zip-code',
  ZIP_CODE_SEARCH: 'ds-mask-zip-code-search',
  NUMBER: function NUMBER(props) {
    return function (_number) {
      return _objectSpread({
        type: 'ds-mask-number'
      }, props);
    };
  },
  PERCENT: function PERCENT(props) {
    return function (_number) {
      return _objectSpread({
        type: 'ds-mask-percent'
      }, props);
    };
  }
};
var maskTypes = [MASK_TYPES.DATE, MASK_TYPES.DATE_DEPRECATED, MASK_TYPES.DATE_TIME, MASK_TYPES.DATE_TIME_DEPRECATED, MASK_TYPES.PHONE, MASK_TYPES.PHONE_INTENATIONAL, MASK_TYPES.SSN, MASK_TYPES.US_ZIP_CODE, MASK_TYPES.NUMBER, MASK_TYPES.PERCENT];

export { MASK_TYPES, maskTypes };
//# sourceMappingURL=MaskTypes.js.map
